export const MY_HARDWARE_TABS = {
  myAssets: "my-assets",
} as const;
